import { createFileRoute } from "@tanstack/react-router"
import { projectDocumentsViewLayoutHandle } from "src/views/ProjectDocumentsView/constants"
import { ProjectDocumentsView } from "src/views/ProjectDocumentsView/ProjectDocumentsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/documents/")({
	component: ProjectDocumentsView,
	staticData: projectDocumentsViewLayoutHandle,
})
